<template>
  <div class="promptPopups">
    <div class="promptPopups-main">
      <div class="promptPopups-main-logo"></div>
      <div class="promptPopups-main-text">
        <div class="promptPopups-con-title">
          <!-- 临近航线 -->
          <template v-if="hasNrpContent.type == 'timeOut'">
            <p style="margin-bottom: 20px;">
              您预订的航线为<span class="activeText">{{ hasNrpContent.title }},</span>
              请仔细阅读以下内容并确认：
            </p>
          </template>
          <template v-else>
            <p v-if="hasNrp && !hasRp">
              您选择的是<span class="activeText">{{ hasNrpContent.title }},</span>
              取消<span class="activeText">需承担取消费用</span>
            </p>
            <p v-if="!hasNrp && hasRp">
              <span>您选择的是</span>
              <span class="activeText">{{ hasNrpContent.title }}，</span>
              开航前第45天起取消<span class="activeText">需承担取消费用</span>
            </p>
            <p v-if="hasNrp && hasRp">
              您的预订同时包含<span class="activeText">收费退订</span>和<span class="activeText">常规退订</span>两种退订模式，
            </p>
          </template>
        </div>
        <div class="promptPopups-con-text" v-if="hasNrpContent.type != 'timeOut'">
          <span v-if="hasNrp && hasRp">具体政策不同。</span>
          请阅读退订政策并确认
        </div>
        <div class="cancellation-text">
          <template v-if="hasNrpContent.type == 'timeOut'">
            <div class="cancellation">
              <div>
                <div v-html="contentData"></div>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="cancellation" v-if="hasNrp && !hasRp">
              <div>
                <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
                <div v-html="cancelPolicyNrp"></div>
              </div>
            </div>
            <div class="cancellation" v-if="!hasNrp && hasRp">
              <div>
                <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
                <div v-html="cancelPolicy">
                </div>
              </div>
            </div>
            <div class="cancellation" v-if="hasNrp && hasRp">
              <div style="margin-bottom: 20px">
                <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
                <div v-html="cancelPolicy"></div>
              </div>
              <div>
                <span style="font-weight: bold">{{ hasNrpContent.titleText }}</span>
                <div v-html="cancelPolicyNrp">
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
      <div class="footer-btn">
        <div class="close-btn" @click="closePromptPopups">返回</div>
        <div class="callPromptBtn" @click="headCallPrompt">确认预订</div>
      </div>
    </div>
  </div>
</template>
<script>
import nrpConfig from '@/utilities/nrpConfig'

export default {
  props: {
    hasNrp: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasRp: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasOutTime: {
      type: Boolean,
      default() {
        return false
      }
    },
    contentData: {
      type: String,
      default() {
        return ''
      }
    },
    cancelPolicy: {
      type: String,
      default() {
        return ''
      }
    },
    cancelPolicyNrp: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      hasNrpContent: '',
    }
  },
  watch: {
    hasNrp: {
      handler() {
        // 延时展示
        setTimeout(() => {
          if (this.hasOutTime) {
            this.hasNrpContent = nrpConfig.outTime
            return
          }
          if (this.hasNrp) {
            this.hasNrpContent = nrpConfig.nrp
          }
          if (this.hasRp) {
            this.hasNrpContent = nrpConfig.rp
          }

          // console.log(this.hasNrpContent, 'this.hasNrpContent')
        }, 20)
      },
      immediate: true
    },

  },
  computed: {},
  methods: {
    closePromptPopups() {
      this.$emit('closePromptPopups')
    },
    headCallPrompt() {
      this.$emit('headCallPrompt')
    },
  }
}
</script>
<style scoped lang="less">
.promptPopups {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 2001;
  background-color: rgba(0, 0, 0, 0.34);
  /* padding: 0 74rpx; */

  .promptPopups-main {
    width: 720px;
    min-height: 447px;
    background-color: #ffffff;
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.1);
    //border-radius: 16px;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;

    .promptPopups-main-logo {
      text-align: center;
      font-size: 20px;
      color: #f8c233;
      width: 80px;
      height: 77px;
      background: url("https://resource.rcclchina.com.cn/logo/PC/logoPopup.png") no-repeat;
      background-size: 100% 100%;
      margin: 15px auto 0;
    }

    .countdown {
      position: absolute;
      right: 10px;
      top: 15px;
      font-size: 15px;
      color: #717171;
    }

    .promptPopups-main-text {
      text-align: center;
      margin-top: 28px;
      padding: 0 30px;

      .promptPopups-con-title {
        font-size: 20px;
        color: #000;

        .activeText {
          color: #f7be33;
        }
      }

      .promptPopups-con-text {
        font-size: 20px;
        color: #000;
        line-height: 20px;
        margin-bottom: 15px;
      }

      .text-con {
        color: #f2ba32;
      }

      .cancellation-text {
        background: #f3f3f3;
        padding: 20px 16px;
        text-align: left;
        max-height: 235px;
        overflow: auto;
        color: #060606;
        font-size: 16px;
      }
    }

    .footer-btn {
      width: 100%;
      height: 49px;
      display: flex;
      margin: 20px auto;
      justify-content: center;
      gap: 95px;

      .close-btn {
        width: 152px;
        font-weight: 600;
        color: #171717;
        line-height: 49px;
        height: 49px;
        text-align: center;
        cursor: pointer;
        border-radius: 3px;
        font-size: 22px;
        background-color: rgba(234, 234, 234, 1);
      }

      .callPromptBtn {
        width: 152px;
        font-size: 22px;
        font-weight: 600;
        color: #060606;
        line-height: 49px;
        height: 49px;
        text-align: center;
        cursor: pointer;
        border-radius: 3px;
        background: linear-gradient(-90deg, #ffd500 0%, #ffbf00 100%);
      }
    }
  }
}
</style>
<style lang="less">
.cancellation-text .cancellation .cabinDetail-box{
  background-color: transparent;
}
.cancellation-text p {
  color: #060606 !important;
  font-size: 16px !important;
  margin: 0;
  line-height: 24px !important;

  span {
    color: #060606 !important;
    font-size: 16px;
  }
}

.cancellation-text .bubbleInfoCon {
  margin-bottom: 13px;

  .nrp_tips .title {
    margin-bottom: 5px;
  }

  .normal_tips .title {
    margin-bottom: 5px;
  }

  .normal_tips .red {
    color: red !important;
  }
}



#pointInPopup{
  position: relative;
  padding-left: 10px;
  box-sizing: border-box;
  &::after{
    content: '';
    position: absolute;
    left: 0;
    top: 8.5px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #060606;
  }
}
</style>
